import { useState, useLayoutEffect } from 'react';

const isPageScrolled = () => {
  if (typeof window === 'undefined') {
    return false;
  } else {
    return window.pageYOffset !== 0;
  }
}

const useWindowYOffset = () => {
  const [isYScrolled, setIsYScrolled] = useState(false);
  const [isFirstRender, setFirstRender] = useState(true);
  
  useLayoutEffect(() => {
    setFirstRender(false);
    const handleScroll = () => {
        setIsYScrolled(isPageScrolled)
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return {isFirstRender, isYScrolled};
};

export default useWindowYOffset;